export default {
  data(){
    return {
      // formSet : {},

      unvalidMessageTemplate  : {
        notEmpty              : 'このフィールドは入力必須です。',
        firstAlpha            : '最初の文字は半角英字で入力してください。',
        alphanumericId        : '半角英数字と(-_)以外の文字が含まれています。',
        alphanumeric          : '半角英数字以外の文字が含まれています。',
        email                 : 'メールアドレスの形式が間違っています。',
        password              : '半角英数字記号８文字以上で入力してください。',
        passwordConfirmation  : 'パスワードが一致しません。入力し直してください。',
        default               : 'エラーが発生しました。',
        max                   : '文字数が多すぎます。２５０文字以下で入力してください。',
      },

      regexValidations : {
        email : {
          pettern : /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        },

        alphanumericId  : {
          pettern : /([a-zA-Z0-9\-_])$/
        },

        firstAlpha      : {
          pettern : /^[a-zA-Z]/
        },
        
        password        : {
          pettern : new RegExp("^[ -~](?=.{7,})"),
        },
      },
    };
  },
  methods : {
    getFieldValues(){
      const values = {};

      for(let i in this.formSet){
        if(typeof this.formSet[i].value !== 'undefined'){
          values[i] = this.formSet[i].value;
        }
      }

      return values;
    },

    flashMessageToScroll(payload){
      const vm = this;

      return new Promise((resolve) => {
        this.$scrollTo('#app', 1000, {
          onDone : function(){
            vm.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : payload.text,
              status      : payload.status,
              hasControl  : payload.cancelBtn,
              autoClose   : payload.autoClose
            }, {root:true});

            resolve();
          }
        });
      });
    },

    disabledFields(payload){
      const options = {
        withDeleteValue : false,
      };

      if(payload !== undefined){
        if(payload.withDeleteValue !== undefined){
          options.withDeleteValue = payload.withDeleteValue;
        }
      }

      for(let i in this.formSet){
        this.formSet[i]['isDisabled'] = true;

        if(options.withDeleteValue){
          this.formSet[i]['value'] = '';
        }
      }
    },

    unDisabledFields(payload){
      const options = {
        withDeleteValue : false,
      };

      if(payload !== undefined){
        if(payload.withDeleteValue !== undefined){
          options.withDeleteValue = payload.withDeleteValue;
        }
      }

      for(let i in this.formSet){
        this.formSet[i]['isDisabled'] = false;

        if(options.withDeleteValue){
          this.formSet[i]['value'] = '';
        }
      }
    },
    
    checkFormPreValidation(){
      for(let fieldName in this.formSet){
        this.validateField(fieldName);
      }

      for(let i in this.formSet){
        if(this.formSet[i]['isUnvalid'] === true){
          return false;
        }
      }

      return true;
    },

    validateField(fieldName){
      for(let formIndex in this.formSet){
        if(formIndex === fieldName){
          const rules = this.formSet[formIndex]['validationRules'];

          for(let i = 0; i < rules.length; i++){
            if( !this.checkValidation(this.formSet[formIndex]['value'], rules[i]) ){
              this.unValidateField({
                fieldName : formIndex,
                message   : this.unvalidMessageTemplate[rules[i]],
              });
              break;
            }else{
              this.formSet[formIndex]['isUnvalid']      = false;
            }
          }
        }
      }
    },

    unValidateField(payload){
      this.formSet[payload.fieldName]['isUnvalid']      = true;
      this.formSet[payload.fieldName]['unvalidMessage'] = payload.message;
    },
    
    checkValidation(value, rule){
      let validationResult = false;

      switch(rule){
        case 'notEmpty':
          if(value !== ''){
            validationResult = true;
          }
        break;

        case 'max':
          var maxLength = 255;

          if( Array.from(value).length < maxLength ){
            validationResult = true;
          }
        break;

        case 'passwordConfirmation':
          if(
            (typeof this.formSet['password_confirmation']['value'] !== 'undefined') &&
            (typeof this.formSet['password']['value'] !== 'undefined')
          ){
            if( this.formSet['password']['value'] === this.formSet['password_confirmation']['value'] ){
              validationResult = true;
            }
          }
        break;

        default:
          if(value.match(this.regexValidations[rule].pettern)){
            validationResult = true;
          }
        break;
      }

      return validationResult;
    },

    toUpperCamelize(text){
      let camelize = this._.camelCase(text);

      return camelize.substring(0, 1).toUpperCase() + camelize.substring(1);
    },

    initializeValid(){
      for(let i in this.formSet){
        this.$set(this.formSet[i], 'isUnvalid',       false);
        this.$set(this.formSet[i], 'unvalidMessage',  this.unvalidMessageTemplate.default);
        
        if(typeof this.formSet[i].isDisabled === 'undefined'){
          this.$set(this.formSet[i], 'isDisabled', false);
        }

        if(typeof this.formSet[i].value === 'undefined'){
          this.$set(this.formSet[i], 'value', '');
        }

        if(typeof this.formSet[i].inputType === 'undefined'){
          this.$set(this.formSet[i], 'inputType', 'input');
        }

        if(
          (this.formSet[i].inputType === 'button') &&
          (typeof this.formSet[i].buttonClass === 'undefined')
        ){
          this.$set(this.formSet[i], 'buttonClass', {
            'is-loading'  : false
          });
        }

        if( typeof this.formSet[i].description === 'undefined' ){
          this.$set(this.formSet[i], 'description', null);
        }

        if( typeof this.formSet[i].descriptionMinify === 'undefined' ){
          this.$set(this.formSet[i], 'descriptionMinify', false);
        }
      }
    }
  },
  created(){
    this.initializeValid();
  }
};
